import { render, staticRenderFns } from "./UsersManagementPage.vue?vue&type=template&id=2311836d"
import script from "./UsersManagementPage.vue?vue&type=script&lang=js"
export * from "./UsersManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports